import { LoadState } from "../../constants/enums";
import { inititalOpportunityState } from "./opportunites.types";
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchOpportunites,
  fetchOpportunitesList,
} from "./opportunitesActions";
import { APIError } from "../../constants/types";

export const opportunitesSlice = createSlice({
  name: "opportunites",
  initialState: inititalOpportunityState,
  reducers: {
    clearOpportunityState: (state) => {
      return inititalOpportunityState;
    },
    clearOpportunity: (state) => {
      state.oppLoading = LoadState.NotLoaded;
      state.opportunity = inititalOpportunityState["opportunity"];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOpportunitesList.pending, (state) => {
        state.loading = LoadState.InProgress;
        state.list = [];
        state.totalRecords = 0;
      })
      .addCase(fetchOpportunitesList.fulfilled, (state, action) => {
        state.loading = LoadState.Loaded;
        state.list = action.payload.data;
        state.totalRecords = action.payload.totalRecords;
      })
      .addCase(fetchOpportunitesList.rejected, (state) => {
        state.loading = LoadState.Failed;
        state.list = [];
        state.totalRecords = 0;
      })
      .addCase(fetchOpportunites.pending, (state) => {
        state.oppLoading = LoadState.InProgress;
        state.opportunity = inititalOpportunityState["opportunity"];
      })
      .addCase(fetchOpportunites.fulfilled, (state, action) => {
        state.oppLoading = LoadState.Loaded;
        state.opportunity = action.payload;
      })
      .addCase(fetchOpportunites.rejected, (state, action) => {
        state.oppLoading = LoadState.Failed;
        state.error = (action.payload as APIError).message;
      });
  },
});

export const { clearOpportunityState, clearOpportunity } =
  opportunitesSlice.actions;

export const opportunitesReducer = opportunitesSlice.reducer;
